<template>
  <v-app id="inspire">
    <org-nav :items="items">
    </org-nav>
    <v-main>
      <router-view />
    </v-main>
    <base-footer/>
  </v-app>
</template>

<script>
import { BaseFooter, OrgNav } from './components'

export default {
  name: 'OrgLayout',
  components: {
    BaseFooter,
    OrgNav
    // AppMain,
    // Navbar,
    // RightPanel,
    // Settings,
    // Sidebar,
    // TagsView
  },
  data () {
    return {

    }
  },
  computed: {
    items () {
      return [
        // {
        //   to: '/seeker/playground',
        //   icon: 'mdi-account-tie',
        //   title: this.$t('message.nav.playground')
        // },
        // {
        //   to: '/org-about',
        //   icon: 'mdi-library',
        //   title: this.$t('message.nav.about')
        // },
        // {
        //   to: '/login',
        //   icon: 'mdi-account-tie',
        //   title: this.$t('message.nav.seeker')
        // },
        // {
        //   to: '/employer-login',
        //   icon: 'mdi-account-tie',
        //   title: this.$t('message.nav.employer')
        // },
        {
          to: '/org/management',
          icon: 'mdi-calendar-multiple',
          title: this.$t('message.nav.org_management')
        },
        {
          to: '/org/org-profile',
          icon: 'mdi-cog',
          title: this.$t('message.nav.org_profile')
        },
        {
          to: '/logout',
          icon: 'mdi-logout',
          title: this.$t('message.nav.logout')
        }

      ]
    }
  }
}
</script>
